// src/client/pages/ResetPassword.jsx
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../core/api';

const ResetPassword = () => {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      const clientKey = localStorage.getItem('selectedClient') || 'le_resto_local';

      await api.post(
        `/api/users/reset-password/${token}`,
        { password },
        { headers: { 'x-client-key': clientKey } }
      );

      setMessage('✅ Mot de passe réinitialisé.');
    } catch (error) {
      console.error('❌ Erreur reset password :', error.response?.data || error.message);
      setMessage('❌ Lien invalide ou expiré.');
    }
  };

  return (
    <div className="auth-container">
      <h2>Nouveau mot de passe</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Nouveau mot de passe"
          required
        />
        <button type="submit">Valider</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default ResetPassword;
